import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const recipeSlice = createSlice({
    name: 'recipe',
    initialState: {
        recipes: []
    },
    reducers: {
        setRecipes: (state, action: PayloadAction<any>) => {
            if (state.recipes.length !== 0) {
                //const newArray = []
                const newArray = action.payload.forEach((item: any) => {
                    return state.recipes.some((recipe: any) => recipe?.recipe_id === item.recipe_id);
                });
                state.recipes = state.recipes.concat(newArray)
            } else {
                state.recipes = action.payload
            }
        }
    }
})

export const { setRecipes } = recipeSlice.actions

export default recipeSlice.reducer